import React, { FC, ReactNode } from "react";
import { Box, Tooltip, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { MyTimeCalendarTooltip } from "my-time/components";

export interface MyTimeCalendarEventWrapperProps {
  /** The calendar event data passed to the tooltip component */
  event: any;
  /** The element(s) to wrap and show the tooltip for */
  children: ReactNode;
}

const StyledTooltip = styled(
  ({ className, ...props }: TooltipProps & { className?: string }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ),
)(() => ({
  "& .MuiTooltip-tooltip": {
    backgroundColor: "#212121",
    borderRadius: "8px",
    padding: "12px 8px",
  },
  "& .MuiTooltip-arrow": {
    color: "#212121",
  },
}));

export const MyTimeCalendarEventWrapper: FC<
  MyTimeCalendarEventWrapperProps
> = ({ event, children }) => {
  return (
    <StyledTooltip title={<MyTimeCalendarTooltip event={event} />} arrow>
      <Box>{children}</Box>
    </StyledTooltip>
  );
};

MyTimeCalendarEventWrapper.displayName = "MyTimeCalendarEventWrapper";

export default MyTimeCalendarEventWrapper;
